export const CATEGORIES = [
  { id: "love", label: "Someone I Love", icon: "Heart" },
  { id: "partner", label: "My Partner", icon: "Rose" },
  { id: "friend", label: "My Best Friend", icon: "Users" },
  { id: "family", label: "Family", icon: "Home" },
  { id: "birthday", label: "Birthday", icon: "Cake" },
  { id: "proposal", label: "Proposal", icon: "Gem" },
  { id: "apology", label: "Apology", icon: "CloudRain" },
  { id: "long_distance", label: "Long Distance", icon: "Plane" },
  { id: "thank_you", label: "Thank You", icon: "Sparkles" },
  { id: "just_because", label: "Just Because", icon: "Mail" },
];

export const EMOTIONS = [
  { id: "warm_love", label: "Warm Love", ink: "#7F1D1D", tint: "#FBEDE7", accent: "#D97757" },
  { id: "missing_you", label: "Missing You", ink: "#3730A3", tint: "#EAE7F5", accent: "#6D67B7" },
  { id: "sorry", label: "I'm Sorry", ink: "#1E3A5F", tint: "#EAEFF2", accent: "#4B7A99" },
  { id: "birthday", label: "Happy Birthday", ink: "#7C2D12", tint: "#FBF1E4", accent: "#D97706" },
  { id: "romantic", label: "Romantic", ink: "#831843", tint: "#FBEAF0", accent: "#DB2777" },
  { id: "long_distance", label: "Long Distance", ink: "#134E4A", tint: "#E7F1EE", accent: "#0F766E" },
  { id: "gratitude", label: "Gratitude", ink: "#3F2A00", tint: "#F6EFDC", accent: "#B8935A" },
  { id: "celebration", label: "Celebration", ink: "#6B21A8", tint: "#F1E9F7", accent: "#9333EA" },
];

export const emotionById = (id) => EMOTIONS.find((e) => e.id === id) || EMOTIONS[0];
export const categoryById = (id) => CATEGORIES.find((c) => c.id === id) || CATEGORIES[0];
